import React, { useState } from "react"
import {
  Plus as PlusIcon,
} from "react-feather"
import { useHistory } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import * as Adm from "@adm"
import RoomIcon from "@material-ui/icons/Room"
import { CheckCircleIcon, Edit, Slash, LinkIcon } from "@iconsGallery"
import {
  Card,
  Grid,
  IconButton,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  Divider,
  Tooltip,
  TextField as MuiTextField,
} from "@material-ui/core"
import styled from "styled-components/macro"
import { spacing } from "@material-ui/system"

import { editTurnstileApi } from "../../../api/turnstileApi"
import { Minimize, AtSign, Hash, Codepen, MapPin, Command } from "react-feather"
import CloseIcon from "@material-ui/icons/Close"
import _ from "lodash"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core/styles"
import DevicesIcon from "@material-ui/icons/Devices"

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)
const TextField = styled(MuiTextField)(spacing)
const noSpaceRegex = /^\S.*\S$|^\S{1}$|^$/
const alphaNumericRegex = /^(?!\d+$)[a-zA-Z0-9 ]+$/

const useStyles = makeStyles((theme) => ({
  textfieldAlignMent: {},
  headerGridStyles: {
    marginBottom: 15,
  },
  textField: {
    width: "100%",
    "& .MuiFormHelperText-contained": {
      color: "red",
      marginLeft: "0px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
  },
  smallTextInput: {
    width: "100% !important",
    "& .MuiFormHelperText-contained": {
      marginLeft: "0px",
    },
  },
  dropDownStyles: {
    marginRight: "20px",
    width: "190px !important",
  },
  customRendeGridClasses: {
    marginLeft: 8,
    marginBottom: 5,
    marginTop: 5,
  },
  labelStyles: {
    paddingLeft: 10,
    fontSize: 16,
    fontWeight: 400,
    color: "#000000",
  },
  valueStyles: {
    fontSize: 18,
    fontWeight: 600,
    color: "#000000",
    wordWrap: "break-word",
  },
  valueOtherStyles: {
    fontSize: 15,
    fontWeight: 400,
  },
  SmallTextField: {
    width: "22%",
    "& .MuiFormHelperText-contained": {
      color: "red",
      marginLeft: "0px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "var(--primaryColor)",
    },
  },
  XLbottomDivider: {
    borderBottom: "0.1em solid rgba(0, 0, 0, 0.1)",
    "@media(min-width:1440px)": {
      "& .MuiGrid-grid-xl-2": {
        flexBasis: "20%",
        maxWidth: "20%",
      },
    },
  },
  bottomDivider: {
    borderBottom: "0.1em solid rgba(0, 0, 0, 0.1)",
  },
  divider: {
    borderRight: "0.1em solid rgba(0, 0, 0, 0.1)",
    padding: "10px 15px",
    margin: "10px 0px",
    "@media(max-width:627px)": {
      padding: "10px",
    },
  },
  textHeader: {
    marginBottom: "15px",
    fontSize: "16px",
  },
  textOtherDetailsHeader: {
    fontSize: "16px",
    "@media(max-width:480px)": {
      marginBottom: "10px",
    },
  },
  icon: {
    marginRight: "8px",
    color: "var(--primaryColor)",
    marginBottom: "-5px",
    fontSize: "30px",
    "@media(max-width:700px)": {
      width: "18px",
      marginRight: "2px",
    },
  },
  noDivider: {
    padding: "10px 15px",
    margin: "10px 0px",
    "@media(max-width:627px)": {
      padding: "10px",
    },
  },
  textInput: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
  },
  disabledTextInput: {
    width: "100%",
    "& input": {
      backgroundColor: "#f6f6f6",
      color: "gray",
    },
  },
  borderBtDivider: {
    padding: "20px 15px",
    borderBottom: "1px solid #eeeeee",
  },
  displayBorderBtDivider: {
    borderBottom: "1px solid #eeeeee",
  },
  verticalDivider: {
    borderBottom: "1px solid #eeeeee",
    padding: "20px 25px",
  },
  textInputDisabled: {
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
  },
  verticalBtmDivider: {
    borderRight: "1px solid #eeeeee",
    borderBottom: "1px solid #eeeeee",
  },
  headTxt1: {
    fontSize: "20px",
    fontWeight: 600,
  },
  labelHead: {
    fontSize: "14px",
    fontWeight: 600,
  },
  otherValueStyles: {
    fontSize: "14px",
  },
  alignCenter: {
    alignSelf: "center",
  },
}))

const FirstEleDetails = ({
  turnstileDetails,
  handleInputChange,
  handleInputDropdownChange,
  handleDedupeModal,
  discardChangesOfFirstEle,
  editApi,
  setAlertMessage,
  setSelectedLocationList = () => {},
  setAlert,
  setAlertType,
  setLoading,
  disableField,
  setAllowPromptCheck = () => {},
  setAllowPrompt = () => {},
  isWriteAllowed,
  isDeleteAllowed,
  deviceMapped = false,
  deleteLoading = false,
  onDeleteClick = () => {},
  onDeleteDisabledClick = () => {},
}) => {
  const history = useHistory()
  const [edit, setEdit] = useState(false)
  const [isAnyChanges, setAnyChanges] = React.useState(false)
  const classes = useStyles()
  const [clickTheCheckMark, setClickTheCheckMark] = useState(false)
  const [val, setVal] = useState("")

  const theme = useTheme()
  const isXStoSM = useMediaQuery(theme.breakpoints.only("xs"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const onlyLGCustomSize = useMediaQuery(theme.breakpoints.only("lg"))
  const onlyXlSize = useMediaQuery(theme.breakpoints.only("xl"))
  const SMCustomSize = useMediaQuery(("(min-width:320px)", "(max-width:480px)"))
  const MDtoLGCustomSize = useMediaQuery(theme.breakpoints.between("sm", "lg"))

  const handleKeyPress = (e, type) => {
    if (type === "number") {
      if (e.which === 32) {
        e.preventDefault()
      }
    } else {
      if (e.which === 32 && e.target.value === "") {
        e.preventDefault()
      }
    }
  }
  function onlyNumbers(event) {
    if (event.type === "paste") {
      var clipboardData = event.clipboardData || window.clipboardData
      var pastedData = clipboardData.getData("Text")
      if (isNaN(pastedData)) {
        event.preventDefault()
      } else {
        return
      }
    }
  }
  return (
    <React.Fragment>
      <Card variant="outlined" style={{ padding: isTablet ? "" : "10px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: "48px",
            margin: "20px",
          }}
        >
          <Typography variant="h4" style={{ fontWeight: "600" }}>
            Turnstile
          </Typography>
          <div style={{ display: "flex", alignItems: "center" }}>
          {edit ? (
            <>
              <Adm.ButtonUI
                typeView={"secondary"}
                title="RESET"
                onClick={() => {
                  setEdit(false)
                  setAnyChanges(false)
                  discardChangesOfFirstEle()
                  setSelectedLocationList([])
                }}
              />

              <Adm.ButtonUI
                typeView={"primary"}
                title="SAVE"
                onClick={() => {
                  let errorIPAddress = false
                  if (
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                      turnstileDetails.turnstileIP
                    )
                  ) {
                    errorIPAddress = true
                  } else {
                    errorIPAddress = false
                  }
                  let errorTrunstilePort = false
                  if (
                    turnstileDetails.turnstileport &&
                    (turnstileDetails?.turnstileport < 1 ||
                      turnstileDetails?.turnstileport > 65534)
                  ) {
                    errorTrunstilePort = false
                  } else {
                    errorTrunstilePort = true
                  }
                  let errorResetTime = false
                  if (
                    turnstileDetails.ResetTime &&
                    (turnstileDetails.ResetTime < 1 ||
                      turnstileDetails.ResetTime > 99)
                  ) {
                    errorResetTime = false
                  } else {
                    errorResetTime = true
                  }

                  setClickTheCheckMark(true)
                  if (!noSpaceRegex.test(turnstileDetails.turnstileName)) {
                    return
                  }
                  if (!alphaNumericRegex.test(turnstileDetails.turnstileName)) {
                    return
                  }

                  if (
                    turnstileDetails.turnstileIP &&
                    turnstileDetails.turnstileloc &&
                    turnstileDetails.turnstileIP.toString().length > 0 &&
                    turnstileDetails.turnstileloc.toString().length > 0 &&
                    turnstileDetails.turnstileport &&
                    turnstileDetails?.CoordinatesX.toString().length > 0 &&
                    turnstileDetails?.CoordinatesY.toString().length > 0 &&
                    _.trim(turnstileDetails?.turnstileName.toString().length) >
                      0 &&
                    _.trim(turnstileDetails?.turnstileName.toString().length) <
                      50 &&
                    turnstileDetails.ResetTime &&
                    errorIPAddress &&
                    errorTrunstilePort &&
                    errorResetTime
                  ) {
                    setAnyChanges(false)
                    editApi(
                      turnstileDetails,
                      history,
                      setAlertMessage,
                      setAlert,
                      setAlertType,
                      setLoading,
                      setEdit
                    )
                    setAllowPrompt(false)
                  } else {
                    return false
                  }
                }}
                style={{
                  padding: "9px",
                  pointerEvents: `${isAnyChanges ? "unset" : "none"}`,
                  color: `${isAnyChanges ? "var(--white)" : "#000"}`,
                  borderColor: `${isAnyChanges ? "var(--white)" : "#CCC"}`,
                  backgroundColor: `${
                    isAnyChanges ? "var(--primaryColor)" : "#CCC"
                  }`,
                }}
              />
            </>
          ) : (
            <>
              <Adm.ButtonUI
                typeView={"primary"}
                title="EDIT"
                aria-label="edit"
                type="button"
                disabled={!isWriteAllowed}
                onClick={() => {
                  setEdit(true)
                }}
              />
            </>
          )}
          <Tooltip
            title={
              deviceMapped ? "Devices mapped. Cannot be deleted." : ""
            }
            placement="top"
          >
            <span
              onClick={() => {
                if (deviceMapped) {
                  onDeleteDisabledClick()
                }
              }}
            >
              {isDeleteAllowed && (
              <Adm.DeleteButtonUI
                typeView={"delete"}
                title="DELETE"
                isDeleteAllowed={isDeleteAllowed}
                disabled={Boolean(deviceMapped) || deleteLoading}
                onClick={() => {
                  if (!deviceMapped && !deleteLoading) {
                    onDeleteClick()
                  }
                }}
              />
              )}
            </span>
          </Tooltip>
          </div>
        </div>
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{ marginTop: 8 }}
        >
          <Grid
            container
            row="true"
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            id="id-mobile-view-device-cf-ui"
            className={classes.XLbottomDivider}
          >
            <Grid
              item
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={SMCustomSize ? 12 : 6}
              className={classes.bottomDivider}
            >
              <div
                className={SMCustomSize ? classes.noDivider : classes.divider}
              >
                <Typography variant="h5" className={classes.textHeader}>
                  <MapPin
                    className={classes.icon}
                    style={{ fontSize: "24px" }}
                  />
                  Store Name <span style={{ color: "red" }}>*</span>
                </Typography>
                {edit ? (
                  <div style={{ display: "flex" }}>
                    <TextField
                      value={turnstileDetails?.locationName}
                      variant="outlined"
                      size="small"
                      className={classes.disabledTextInput}
                      type="text"
                      name="locationName"
                      disabled
                    />
                    <Tooltip title="Change Store">
                      <IconButton
                        onClick={() => {
                          setAllowPromptCheck(turnstileDetails?.locationName)
                          handleDedupeModal("Select Store")
                          setAnyChanges(true)
                        }}
                        style={{ padding: "5px", marginLeft: "5px" }}
                      >
                        <LinkIcon
                          style={{ marginTop: "-5px", cursor: "pointer" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  <Typography variant="h3" className={classes.valueStyles}>
                    {turnstileDetails?.locationName}
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid
              item
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={SMCustomSize ? 12 : 6}
              className={classes.bottomDivider}
            >
              <div
                className={
                  SMCustomSize || isXStoSM ? classes.noDivider : classes.divider
                }
              >
                <Typography variant="h5" className={classes.textHeader}>
                  <Hash className={classes.icon} style={{ fontSize: "24px" }} />
                  Store Number <span style={{ color: "red" }}>*</span>
                </Typography>
                {edit && !disableField ? (
                  <TextField
                    value={turnstileDetails?.LocNum}
                    variant="outlined"
                    size="small"
                    className={classes.disabledTextInput}
                    type="text"
                    name="LocNum"
                    disabled
                  />
                ) : (
                  <Typography variant="h3" className={classes.valueStyles}>
                    <>
                      {turnstileDetails &&
                        turnstileDetails.LocNum &&
                        turnstileDetails.LocNum}
                    </>
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid
              item
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={SMCustomSize ? 12 : 6}
              className={classes.bottomDivider}
            >
              <div
                className={
                  SMCustomSize || isXStoSM || onlyLGCustomSize
                    ? classes.noDivider
                    : classes.divider
                }
              >
                <Typography variant="h5" className={classes.textHeader}>
                  <Minimize className={classes.icon} />
                  Turnstile ID <span style={{ color: "red" }}>*</span>
                </Typography>
                <Typography
                  variant="h3"
                  className={classes.valueStyles}
                  style={{ height: isTablet || onlyXlSize ? "35px" : "" }}
                >
                  <>
                    {turnstileDetails &&
                      turnstileDetails.turnstileID &&
                      turnstileDetails.turnstileID}
                  </>
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={SMCustomSize ? 12 : 6}
              className={
                (MDtoLGCustomSize ||
                  SMCustomSize ||
                  isXStoSM ||
                  onlyLGCustomSize ||
                  onlyXlSize) &&
                !isTablet
                  ? classes.bottomDivider
                  : ""
              }
            >
              <div
                className={
                  SMCustomSize || onlyXlSize
                    ? classes.noDivider
                    : classes.divider
                }
              >
                <Typography variant="h5" className={classes.textHeader}>
                  <AtSign className={classes.icon} />
                  Turnstile Name <span style={{ color: "red" }}>*</span>
                </Typography>
                {edit ? (
                  <TextField
                    type="text"
                    className={classes.textField}
                    variant="outlined"
                    name="turnstileName"
                    error={
                      clickTheCheckMark &&
                      !alphaNumericRegex.test(turnstileDetails.turnstileName)
                        ? true
                        : clickTheCheckMark &&
                          !noSpaceRegex.test(turnstileDetails.turnstileName)
                        ? true
                        : turnstileDetails.turnstileName === null
                        ? true
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileName !== null &&
                          turnstileDetails.turnstileName?.toString().length ===
                            0
                        ? true
                        : (clickTheCheckMark &&
                            turnstileDetails.turnstileName !== null &&
                            turnstileDetails.turnstileName?.toString().length <
                              3) ||
                          turnstileDetails.turnstileName?.toString().length > 50
                        ? true
                        : false
                    }
                    helperText={
                      clickTheCheckMark &&
                      !alphaNumericRegex.test(turnstileDetails.turnstileName)
                        ? "Special characters & only numbers are not allowed"
                        : clickTheCheckMark &&
                          !noSpaceRegex.test(turnstileDetails.turnstileName)
                        ? "No spaces allowed at the start or end"
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileName === null
                        ? "Enter Turnstile Name"
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileName !== null &&
                          turnstileDetails.turnstileName?.toString().length ===
                            0
                        ? "Enter Turnstile Name"
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileName !== null &&
                          (turnstileDetails.turnstileName?.toString().length <
                            3 ||
                            turnstileDetails.turnstileName?.toString().length >
                              50)
                        ? "Min - 3 characters Max - 50"
                        : false
                    }
                    placeholder="Enter Turnstile IP"
                    size="small"
                    autoComplete="off"
                    value={turnstileDetails.turnstileName}
                    onBlur={(e) => {
                      setAllowPromptCheck(turnstileDetails.turnstileName)
                      handleInputChange(e)
                    }}
                    onChange={(e) => {
                      setAllowPromptCheck(turnstileDetails.turnstileName)
                      setAnyChanges(true)
                      handleInputChange(e)
                    }}
                  />
                ) : (
                  <Typography
                    style={{ wordWrap: "break-word" }}
                    variant="h3"
                    className={classes.valueStyles}
                  >
                    {turnstileDetails && turnstileDetails.turnstileName
                      ? turnstileDetails.turnstileName
                      : "-"}
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid
              item
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={SMCustomSize ? 12 : 6}
              className={
                SMCustomSize || isXStoSM || isTablet
                  ? classes.bottomDivider
                  : ""
              }
            >
              <div
                className={
                  SMCustomSize || isXStoSM || isTablet
                    ? classes.noDivider
                    : classes.divider
                }
              >
                <Typography variant="h5" className={classes.textHeader}>
                  <AtSign className={classes.icon} />
                  Turnstile IP <span style={{ color: "red" }}>*</span>
                </Typography>
                {edit && !disableField ? (
                  <TextField
                    type="text"
                    className={classes.textField}
                    variant="outlined"
                    name="turnstileIP"
                    error={
                      clickTheCheckMark && turnstileDetails.turnstileIP === null
                        ? true
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileIP !== null &&
                          turnstileDetails.turnstileIP.toString().length === 0
                        ? true
                        : turnstileDetails.turnstileIP !== null &&
                          !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            turnstileDetails.turnstileIP
                          )
                        ? true
                        : false
                    }
                    helperText={
                      clickTheCheckMark && turnstileDetails.turnstileIP === null
                        ? "Enter IP Address"
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileIP !== null &&
                          turnstileDetails.turnstileIP.toString().length === 0
                        ? "Enter IP Address"
                        : turnstileDetails.turnstileIP !== null &&
                          !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            turnstileDetails.turnstileIP
                          )
                        ? "Invalid IP Address"
                        : false
                    }
                    placeholder="Enter Turnstile IP"
                    size="small"
                    value={turnstileDetails.turnstileIP}
                    onChange={(e) => {
                      setAllowPromptCheck(turnstileDetails.turnstileIP)
                      setAnyChanges(true)
                      handleInputChange(e)
                    }}
                    onKeyPress={(e) => handleKeyPress(e, "number")}
                  />
                ) : (
                  <Typography variant="h3" className={classes.valueStyles}>
                    {turnstileDetails &&
                      turnstileDetails.turnstileIP &&
                      turnstileDetails.turnstileIP}
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid
              item
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={SMCustomSize ? 12 : 6}
              className={
                SMCustomSize || isXStoSM || isTablet
                  ? classes.bottomDivider
                  : ""
              }
            >
              <div
                className={
                  SMCustomSize || isXStoSM || isTablet
                    ? classes.noDivider
                    : classes.divider
                }
              >
                <Typography variant="h5" className={classes.textHeader}>
                  <Codepen
                    className={classes.icon}
                    style={{ fontSize: "24px" }}
                  />
                  Install Location <span style={{ color: "red" }}>*</span>
                </Typography>
                {edit && !disableField ? (
                  <Adm.DropdownKit
                    className={classes.smallTextInput}
                    list={["Entry", "Exit"]}
                    placeholder="Select"
                    error={
                      clickTheCheckMark &&
                      turnstileDetails.turnstileloc === null
                        ? "Select Install Location"
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileloc !== null &&
                          turnstileDetails.turnstileloc.toString().length === 0
                        ? "Select Install Location"
                        : ""
                    }
                    defaultValue={turnstileDetails.turnstileloc || ""}
                    onUpdate={(val) => {
                      setAllowPromptCheck(val)
                      setAnyChanges(true)
                      handleInputDropdownChange(val)
                    }}
                  />
                ) : (
                  <Typography variant="h3" className={classes.valueStyles}>
                    {turnstileDetails &&
                      turnstileDetails.turnstileloc &&
                      turnstileDetails.turnstileloc}
                  </Typography>
                )}
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            item
            md={12}
            lg={12}
            className={classes.borderBtDivider}
          >
            <Typography
              style={{
                fontWeight: 600,
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {" "}
              <DevicesIcon style={{ marginRight: "10px" }} />
              Other Details
            </Typography>
          </Grid>
          <Grid
            container
            direction="row"
            item
            md={12}
            lg={12}
            xs={12}
            sm={12}
            xl={12}
          >
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              direction="row"
              className={classes.verticalDivider}
            >
              <Grid
                item
                md={5}
                lg={5}
                xs={SMCustomSize ? 12 : 5}
                sm={5}
                xl={4}
                className={classes.alignCenter}
              >
                <Typography
                  variant="h5"
                  className={classes.textOtherDetailsHeader}
                >
                  {" "}
                  Turnstile port <span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item md={5} lg={4} xs={SMCustomSize ? 12 : 7} sm={5} xl={3}>
                {edit && !disableField ? (
                  <TextField
                    type="number"
                    style={{ width: "100%" }}
                    className={classes.textField}
                    variant="outlined"
                    name="turnstileport"
                    placeholder="Enter Turnstile port"
                    error={
                      clickTheCheckMark &&
                      turnstileDetails.turnstileport === null
                        ? true
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileport !== null &&
                          turnstileDetails.turnstileport.toString().length === 0
                        ? true
                        : turnstileDetails.turnstileport !== null &&
                          (turnstileDetails?.turnstileport < 1 ||
                            turnstileDetails?.turnstileport > 65534)
                        ? true
                        : false
                    }
                    helperText={
                      clickTheCheckMark &&
                      turnstileDetails.turnstileport === null
                        ? "Enter Port Number"
                        : clickTheCheckMark &&
                          turnstileDetails.turnstileport !== null &&
                          turnstileDetails.turnstileport.toString().length === 0
                        ? "Enter Port Number"
                        : turnstileDetails.turnstileport !== null &&
                          (turnstileDetails?.turnstileport < 1 ||
                            turnstileDetails?.turnstileport > 65534)
                        ? "Turnstile Port should be should be 1 - 65534"
                        : false
                    }
                    onKeyPress={(event) => {
                      if (
                        event?.key === "-" ||
                        event?.key === "+" ||
                        event?.key === "."
                      ) {
                        event.preventDefault()
                      }
                    }}
                    InputProps={{
                      inputProps: { min: 0 },
                      style: { marginLeft: 0 },
                    }}
                    size="small"
                    value={turnstileDetails.turnstileport}
                    onChange={(e) => {
                      setAllowPromptCheck(turnstileDetails.turnstileport)
                      setAnyChanges(true)
                      handleInputChange(e)
                    }}
                    onPaste={(evt) => onlyNumbers(evt)}
                  />
                ) : (
                  <Typography className={classes.valueOtherStyles}>
                    {turnstileDetails &&
                      turnstileDetails.turnstileport &&
                      turnstileDetails.turnstileport}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              direction="row"
              className={classes.verticalDivider}
            >
              <Grid
                item
                md={5}
                lg={5}
                xs={SMCustomSize ? 12 : 5}
                sm={5}
                xl={4}
                className={classes.alignCenter}
              >
                <Typography
                  variant="h5"
                  className={classes.textOtherDetailsHeader}
                >
                  {`Location in store`}{" "}
                  <span style={{ fontSize: "10px" }}>(in Feet)</span>
                  <span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item md={5} lg={4} xs={SMCustomSize ? 12 : 7} sm={5} xl={3}>
                {edit && !disableField ? (
                  <Grid style={{ display: "flex" }}>
                    <TextField
                      type="number"
                      className={classes.SmallTextField}
                      style={{ marginRight: "5px", width: "50%" }}
                      variant="outlined"
                      name="CoordinatesX"
                      error={
                        clickTheCheckMark &&
                        turnstileDetails.CoordinatesX === null
                          ? true
                          : clickTheCheckMark &&
                            turnstileDetails.CoordinatesX !== null &&
                            turnstileDetails.CoordinatesX.toString().length ===
                              0
                          ? true
                          : false
                      }
                      helperText={
                        clickTheCheckMark &&
                        turnstileDetails.CoordinatesX === null
                          ? "Enter X-axis"
                          : clickTheCheckMark &&
                            turnstileDetails.CoordinatesX !== null &&
                            turnstileDetails.CoordinatesX.toString().length ===
                              0
                          ? "Enter X-axis"
                          : false
                      }
                      placeholder="Enter X"
                      label="X-Axis"
                      size="small"
                      value={turnstileDetails?.CoordinatesX}
                      onChange={(e) => {
                        setAllowPromptCheck(turnstileDetails.CoordinatesX)
                        setAnyChanges(true)
                        handleInputChange(e)
                      }}
                      onKeyPress={(event) => {
                        if (event?.key === "-" || event?.key === "+") {
                          event.preventDefault()
                        }
                      }}
                      onPaste={(evt) => onlyNumbers(evt)}
                      InputProps={{ inputProps: { min: 0 } }}
                    />
                    <div style={{ fontSize: 15, marginTop: 10 }} />
                    <TextField
                      type="number"
                      className={classes.SmallTextField}
                      style={{ marginLeft: "5px", width: "50%" }}
                      variant="outlined"
                      name="CoordinatesY"
                      error={
                        clickTheCheckMark &&
                        turnstileDetails.CoordinatesY === null
                          ? true
                          : clickTheCheckMark &&
                            turnstileDetails.CoordinatesY !== null &&
                            turnstileDetails.CoordinatesY.toString().length ===
                              0
                          ? true
                          : false
                      }
                      helperText={
                        clickTheCheckMark &&
                        turnstileDetails.CoordinatesY === null
                          ? "Enter X-axis"
                          : clickTheCheckMark &&
                            turnstileDetails.CoordinatesY !== null &&
                            turnstileDetails.CoordinatesY.toString().length ===
                              0
                          ? "Enter X-axis"
                          : false
                      }
                      placeholder="Enter Y"
                      label="Y-Axis"
                      size="small"
                      value={turnstileDetails?.CoordinatesY}
                      onChange={(e) => {
                        setAllowPromptCheck(turnstileDetails.CoordinatesY)
                        setAnyChanges(true)
                        handleInputChange(e)
                      }}
                      onKeyPress={(event) => {
                        if (event?.key === "-" || event?.key === "+") {
                          event.preventDefault()
                        }
                      }}
                      onPaste={(evt) => onlyNumbers(evt)}
                      InputProps={{ inputProps: { min: 0 } }}
                    />
                  </Grid>
                ) : (
                  <Typography variant="h3" className={classes.valueOtherStyles}>
                    <Grid style={{ display: "flex" }}>
                      {turnstileDetails &&
                      turnstileDetails.CoordinatesX === null &&
                      turnstileDetails.CoordinatesY === null
                        ? ""
                        : `${turnstileDetails?.CoordinatesX}, ${turnstileDetails?.CoordinatesY}`}
                    </Grid>
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              direction="row"
              className={classes.verticalDivider}
            >
              <Grid
                item
                md={5}
                lg={5}
                xs={SMCustomSize ? 12 : 5}
                sm={5}
                xl={4}
                className={classes.alignCenter}
              >
                <Typography
                  variant="h5"
                  className={classes.textOtherDetailsHeader}
                >
                  {" "}
                  Reset time <span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item md={5} lg={4} xs={SMCustomSize ? 12 : 7} sm={5} xl={3}>
                {edit && !disableField ? (
                  <TextField
                    type="number"
                    style={{ width: "100%" }}
                    className={classes.textField}
                    error={
                      clickTheCheckMark && turnstileDetails.ResetTime === null
                        ? true
                        : clickTheCheckMark &&
                          turnstileDetails.ResetTime !== null &&
                          turnstileDetails.ResetTime.toString().length === 0
                        ? true
                        : turnstileDetails.ResetTime !== null &&
                          (turnstileDetails.ResetTime < 1 ||
                          turnstileDetails.ResetTime > 99
                            ? true
                            : false)
                    }
                    helperText={
                      clickTheCheckMark && turnstileDetails.ResetTime === null
                        ? "Enter Reset Time"
                        : clickTheCheckMark &&
                          turnstileDetails.ResetTime !== null &&
                          turnstileDetails.ResetTime.toString().length === 0
                        ? "Enter Reset Time"
                        : turnstileDetails.ResetTime !== null &&
                          (turnstileDetails.ResetTime < 1 ||
                          turnstileDetails.ResetTime > 99
                            ? "Reset time should be 1 - 99"
                            : false)
                    }
                    onKeyDown={(e) =>
                      (e.keyCode === 69 || e.keyCode === 190) &&
                      e.preventDefault()
                    }
                    onKeyPress={(event) => {
                      if (
                        event?.key === "-" ||
                        event?.key === "+" ||
                        event?.key === "." ||
                        event?.key === 190
                      ) {
                        event.preventDefault()
                      }
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    variant="outlined"
                    name="ResetTime"
                    placeholder="Reset Time"
                    size="small"
                    value={turnstileDetails.ResetTime}
                    onChange={(e) => {
                      setVal(e.target.value.replace(/[^0-9]/g, ""))
                      setAllowPromptCheck(turnstileDetails.ResetTime)
                      setAnyChanges(true)
                      handleInputChange(e)
                    }}
                    onPaste={(evt) => onlyNumbers(evt)}
                  />
                ) : (
                  <Typography className={classes.valueOtherStyles}>
                    {turnstileDetails &&
                      turnstileDetails.ResetTime &&
                      turnstileDetails.ResetTime}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </React.Fragment>
  )
}

export default FirstEleDetails
